import Flux    from '../../flux/Flux';
import {VXPay} from '../../utils/VXPay';


export const openVipPayTour = () => {
	if (!Flux.Guest.isLoggedIn()) {
		VXPay.openLogin();
		return;
	}
	VXPay.openAboPaytour();
};
